import { render, staticRenderFns } from "./VirtualScrollDemo.vue?vue&type=template&id=4610f60f&scoped=true"
import script from "./VirtualScrollDemo.vue?vue&type=script&lang=js"
export * from "./VirtualScrollDemo.vue?vue&type=script&lang=js"
import style0 from "./VirtualScrollDemo.vue?vue&type=style&index=0&id=4610f60f&prod&lang=scss&scoped=true"
import style1 from "./VirtualScrollDemo.vue?vue&type=style&index=1&id=4610f60f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610f60f",
  null
  
)

export default component.exports